
import FaqItem from "./faq-item";
export default {
  name: "faq",
  components: {
    FaqItem,
  },
  data() {
    return {
      faqs: [
        {
          question: "How does mobile monitoring work?",
          answer:
          'If you notice unfamiliar numbers on your partner’s phone you can use our LISTING LOCATOR service to discover who that number belongs to. We also have active mobile phone monitoring services that will be launching soon.',
          open: false,
        },
        {
          question: "Can I enter more than one email?",
          answer:
            "Once you have purchased search credits you can use them to search using any email you think might be involved. The Monthly options allow you to run searches on several emails at the same time.",
          open: false,
        },
        {
          question: "Can I check by entering a name only?",
          answer:
            "Most online sites/apps require users to enter a name and email address or mobile phone number. They may not be using their given name, maybe a nickname instead, having an email address increases the search power. Our LISTING LOCATOR can help you find other phone numbers or email addresses your partner might be using.",
          open: false,
        },
        {
          question: "How do I find out if my partner is cheating?",
          answer:
            "iFindCheaters offers a variety of services to help you discover if your partner is active online. Once you know which sites or apps they are users of, then you can do more research. You may want to start by verifying that the information they have given you is genuine by using our LISTING LOCATOR service.",
          open: false,
        },
        {
          question: "Is it possible to catch a cheater by cell phone?",
          answer:
            "If someone uses more than one number to activate the SIM card they will need to give a valid ID. As such if that phone number has been used to access apps or sites our different search services can find those accounts. If you use a LISTING LOCATOR search to verify your partner’s name and discover that they have not been honest about information they have given you then be extra cautious.",
          open: false,
        },
        {
          question:
            "How do I learn if my partner has other email addresses or phone numbers they use",
          answer:"To verify identities is the first step to putting your mind at ease. After that if you want to be extra sure you can use one of our other services to find all profiles linked to email address. You have the right to search online accounts by email, and in the process you might even catch a cheater by cell phone.",
          open: false,
        },
        {
          question: "LISTING LOCATOR",
          answer:"This service enables you to get information to verify identity, relationship status, physical addresses, telephone numbers and email. You can search for this information by entering their name, phone number, physical address or email. Whatever piece of information they have given you can be verified in one simple search.",
          open: false,
        },
        {
          question:
            "How will this charge appear on my bank or credit card statement?",
          answer:
            "When you use your credit or debit card the charge will appear as iFC Search Products on your monthly statement.",
          open: false,
        },
        {
          question:
            "How can I pay with a prepaid card? ",
          answer:
            "You enter the information for a prepaid card just as you would any other credit or debit card. There is technically no billing address with a prepaid card, but the fields will still need to be completed for the charge to be processed.",
          open: false,
        },
        {
          question:
            "How can I pay so it won’t show on my bank or credit card statement? ",
          answer:
            "If you do not want to provide a debit or credit card for fear of raising suspicion you may use a prepaid card or create a PayPal account which many people use for shopping online.",
          open: false,
        },
      ],
    };
  },
  methods: {
    toggleOpen: function (index) {
      this.faqs = this.faqs.map((faq, i) => {
        if (index === i) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }
        return faq;
      });
    },
  },
};
